import React from "react";
import { CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRequestFeedback } from "@/components/pages/requests/hooks/requestFeedback.hooks";
import { useAccessCapabilities } from "@/hooks/useAccessCapabilities";
import FeedbackItem from "./FeedbackItem";

type Props = { requestId: string };

export const FeedbackSection: React.FC<Props> = ({ requestId }) => {
  const { hasFeedbacksAccess } = useAccessCapabilities();
  const { data: feedback, isLoading } = useRequestFeedback(
    { requestId },
    hasFeedbacksAccess,
  );

  if (!hasFeedbacksAccess) return null;

  if (isLoading || !feedback) return null;

  return (
    <div className="space-y-3">
      <CardHeader className="p-0">
        <CardTitle>Feedback</CardTitle>
      </CardHeader>
      <CardContent className="p-0 space-y-2">
        <FeedbackItem feedback={feedback} />
      </CardContent>
    </div>
  );
};

export default FeedbackSection;
